var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cms-text-block"},[(_vm.block.title)?_c('h3',{staticClass:"cms-text-block-title"},[_vm._v(_vm._s(_vm.block.title))]):_vm._e(),(_vm.block.bodyContent)?_c('div',{staticClass:"cms-text-block-body",domProps:{"innerHTML":_vm._s(_vm.block.bodyContent)}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }